var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPrisma(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 144,
    viewBox: "0 0 118 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.05731 91.2538C-0.372741 93.5865 -0.350609 96.5297 1.11436 98.8407L27.6299 140.668C29.3508 143.383 32.6679 144.621 35.7465 143.697L112.264 120.742C116.44 119.489 118.541 114.831 116.716 110.872L67.5265 4.16889C65.1276 -1.03475 57.8961 -1.46189 54.9013 3.42317L1.05731 91.2538ZM66.2195 28.5622C65.1741 26.1431 61.6338 26.5157 61.1149 29.0995L42.1773 123.393C41.778 125.381 43.6395 127.079 45.5827 126.499L98.4502 110.718C99.9933 110.257 100.788 108.553 100.149 107.074L66.2195 28.5622Z",
    fill: "#5A67D8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrisma);
export default __webpack_public_path__ + "static/media/icon_prisma.a67cb0c02b2682746f9a73170d683bc3.svg";
export { ForwardRef as ReactComponent };